import React, { Component, PropTypes } from 'react'
import { Card, CardHeader, CardText } from 'material-ui/Card'
import {
  Table,
  TableBody,
  TableFooter,
  TableRow,
  TableRowColumn
} from 'material-ui/Table'

import api from '../../../api'
import ValueLink from './value-link'

const styles = {
  table: {
    maxWidth: '400px'
  }
}

class ReservationSummary extends Component<any, any> {
  constructor (props) {
    super(props)
    this.state = {
      isLoaded: false
    }
  }

  componentWillMount () {
    this.loadCounts().then(() => {
      this.setState({ isLoaded: true })
    })
  }

  loadCounts () {
    return Promise.all([
      this.countAssigned(),
      this.countUnassigned()
    ])
  }

  countAssigned () {
    const body = {
      filters: {
        session_sale_id: this.props.sessionSaleId,
        user_id_null: 'false'
      }
    }

    return api.get('admin/session_reservations/count', { body })
      .then(res => res.json())
      .then(body => {
        this.setState({ numAssigned: body.result })
        return body
      })
  }

  countUnassigned () {
    const body = {
      filters: {
        session_sale_id: this.props.sessionSaleId,
        user_id_null: 'true'
      }
    }

    return api.get('admin/session_reservations/count', { body })
      .then(res => res.json())
      .then(body => {
        this.setState({ numUnassigned: body.result })
        return body
      })
  }

  render () {
    if (!this.state.isLoaded) return null

    const { sessionSaleId } = this.props
    const { numAssigned, numUnassigned } = this.state
    const path = `/events/session-sales/${sessionSaleId}/reservations`

    return (
      <Card>
        <CardHeader
          title='Reservation Summary'
        />

        <CardText>
          <Table
            style={styles.table}
            selectable={false}
          >
            <TableBody
              selectable={false}
              displayRowCheckbox={false}
            >
              <TableRow>
                <TableRowColumn>Assigned</TableRowColumn>
                <TableRowColumn>
                  <ValueLink
                    value={numAssigned}
                    path={path + '?filters[user_id_null]=false'}
                  />
                </TableRowColumn>
              </TableRow>
              <TableRow>
                <TableRowColumn>Unassigned</TableRowColumn>
                <TableRowColumn>
                  <ValueLink
                    value={numUnassigned}
                    path={path + '?filters[user_id_null]=true'}
                  />
                </TableRowColumn>
              </TableRow>
            </TableBody>
            <TableFooter adjustForCheckbox={false}>
              <TableRow>
                <TableRowColumn>Total</TableRowColumn>
                <TableRowColumn>
                  <ValueLink
                    value={numAssigned + numUnassigned}
                    path={path}
                  />
                </TableRowColumn>
              </TableRow>
            </TableFooter>
          </Table>
        </CardText>
      </Card>
    )
  }
}

// @ts-ignore
ReservationSummary.propTypes = {
  sessionSaleId: PropTypes.string.isRequired
}

export default ReservationSummary
